import React, { useState, useEffect, useContext } from "react";
import { useAuth } from "react-oidc-context";
import { HotelContext } from "../../context/HotelContext";
import { translate } from "../../utils/Translation";
import { useV2MonthYear } from "../../hooks/useV2MonthYear";
import "./Page.css";
import "./ActionsSurveys.css";
import MonthYearNavigator from "./MonthYearNavigator";
import ActionsSurveysSections from "./ActionsSurveysSections";
// @ts-ignore - ignore type resolution for png assets
import emoji4 from "../../img/v2/Emojis/4.png";
// @ts-ignore - ignore type resolution for png assets
import emoji3 from "../../img/v2/Emojis/3.png";
// @ts-ignore - ignore type resolution for png assets
import emoji2 from "../../img/v2/Emojis/2.png";
// @ts-ignore - ignore type resolution for png assets
import emoji1 from "../../img/v2/Emojis/1.png";
// @ts-ignore - ignore type resolution for png assets
import userIcon from "../../img/v2/Emojis/Utilisateur.png";

const ActionsSurveys = () => {
  const auth = useAuth();
  const { hId, lang } = useContext(HotelContext);
  
  const [reviews, setReviews] = useState([]);
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [expandedQuizzes, setExpandedQuizzes] = useState(() => {
    // Initialiser avec le premier quiz ouvert par défaut (géré après le fetch)
    return {};
  });
  
  // Mois / année (persistée entre pages)
  const { month: selectedMonth, year: selectedYear, setMonthYear } = useV2MonthYear();

  // Données factices pour les graphiques de période
  const mockReviewPeriodData = [
    { day: "lun", "Label Clef verte": 12, "Action 2": 8 },
    { day: "mar", "Label Clef verte": 15, "Action 2": 10 },
    { day: "mer", "Label Clef verte": 18, "Action 2": 12 },
    { day: "jeu", "Label Clef verte": 14, "Action 2": 9 },
    { day: "ven", "Label Clef verte": 16, "Action 2": 11 },
    { day: "sam", "Label Clef verte": 10, "Action 2": 7 },
    { day: "dim", "Label Clef verte": 8, "Action 2": 5 },
  ];

  const mockQuizPeriodData = [
    { day: "lun", "Quiz 1": 5, "Quiz 2": 3, "Quiz 3": 2 },
    { day: "mar", "Quiz 1": 7, "Quiz 2": 4, "Quiz 3": 3 },
    { day: "mer", "Quiz 1": 9, "Quiz 2": 5, "Quiz 3": 4 },
    { day: "jeu", "Quiz 1": 6, "Quiz 2": 4, "Quiz 3": 3 },
    { day: "ven", "Quiz 1": 8, "Quiz 2": 5, "Quiz 3": 4 },
    { day: "sam", "Quiz 1": 4, "Quiz 2": 3, "Quiz 3": 2 },
    { day: "dim", "Quiz 1": 3, "Quiz 2": 2, "Quiz 3": 1 },
  ];

  // Fonction pour obtenir l'image et la couleur selon le vote
  const getSentimentData = (vote) => {
    switch (vote) {
      case 4:
        return { img: emoji4, color: "#697F6A" };
      case 3:
        return { img: emoji3, color: "#96B77A" }; 
      case 2:
        return { img: emoji2, color: "#B0C996" }; 
      case 1:
      default:
        return { img: emoji1, color: "#CFA7A0" }; 
    }
  };

  const getSentimentImg = (vote) => getSentimentData(vote).img;
  const getSentimentColor = (vote) => getSentimentData(vote).color;

  // Charger les statistiques des sondages
  useEffect(() => {
    const fetchSurveysStats = async () => {
      if (!auth.isAuthenticated || !auth.user?.access_token || !hId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(false);

        const response = await fetch(`/api/hotels/${hId}/surveys-stats?year=${selectedYear}&month=${selectedMonth}&lang=${lang}`, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + auth.user.access_token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-front-token": "Bs#PSQyhy)!y9Ti{",
          },
        });

        if (!response.ok) {
          console.error("Error fetching surveys stats:", response.status, response.statusText);
          const errorData = await response.json().catch(() => ({}));
          console.error("Error data:", errorData);
          throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.success === "OK") {
          setReviews(data.reviews || []);
          const quizzesData = data.quizzes || [];
          setQuizzes(quizzesData);
          // Ouvrir le premier quiz par défaut
          if (quizzesData.length > 0) {
            setExpandedQuizzes({ [quizzesData[0].actId]: true });
          } else {
            setExpandedQuizzes({});
          }
        } else {
          setReviews([]);
          setQuizzes([]);
          setExpandedQuizzes({});
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetching surveys stats:", err);
        setError(true);
        setLoading(false);
      }
    };

    if (auth.isAuthenticated && hId) {
      fetchSurveysStats();
    }
  }, [auth.isAuthenticated, auth.user?.access_token, hId, selectedYear, selectedMonth, lang]);

  return (
    <div className="v2-page">
      <div className="v2-page__header">
        <h1>{translate("v2_actions_surveys_title", lang)}</h1>
        <MonthYearNavigator
          month={selectedMonth}
          year={selectedYear}
          onChange={({ month, year }) => {
            setMonthYear({ month, year });
          }}
        />
      </div>
      <div className="v2-page__content">
        <ActionsSurveysSections
          loading={loading}
          error={error}
          reviews={reviews}
          quizzes={quizzes}
          expandedQuizzes={expandedQuizzes}
          setExpandedQuizzes={setExpandedQuizzes}
          getSentimentColor={getSentimentColor}
          getSentimentImg={getSentimentImg}
          userIcon={userIcon}
          mockReviewPeriodData={mockReviewPeriodData}
          mockQuizPeriodData={mockQuizPeriodData}
        />
      </div>
    </div>
  );
};

export default ActionsSurveys;
